import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
            <i className="ri-article-line text-primary-500 mr-2"></i>
            热门爆料图文速览
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            精选今日最值得关注的热门大瓜，图文并茂吃瓜更尽兴
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {cardsData.map((card) => (
              <div
                key={card.id}
                className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all hover:translate-y-[-2px] flex flex-col"
              >
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top transition-transform group-hover:scale-105"
                  />
                  <span className="absolute top-2 left-2 px-2 py-0.5 rounded bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="p-3 flex-1 flex flex-col">
                  <h3 className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug mb-2">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                    {card.desc}
                  </p>
                  <div className="flex items-center justify-between mt-auto text-xs text-foreground-500">
                    <span className="whitespace-nowrap">{card.time}</span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line"></i>
                      {card.views}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}